import React from "react";
import { Box } from "@mui/material";

const BoxWrapper = ({ children, ...otherProps }: any) => {
  return <Box {...otherProps}>{children}</Box>;
};

export default BoxWrapper;
